export default __webpack_public_path__ + "static/media/2310.c4748303.png";